/* eslint-disable func-style */
const Login = () => import('../pages/Login/Login.vue');

const LoginRouter = [
	{ path: '/login', name: 'Login', component: Login },
];

export default LoginRouter;
